exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#pro-job-title-view {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  background: #039be5;\n  color: #fff;\n  padding-left: 20px;\n  padding-top: 10px;\n  position: sticky;\n  top: 0; }\n\n.header-stick {\n  height: 260px;\n  overflow: auto; }\n\n.list {\n  font-size: 17px; }\n\n.close-button {\n  color: white; }\n\n.list-container {\n  padding-top: 18px;\n  margin-left: 10px; }\n\n.pic-upload-view {\n  padding-top: 20px;\n  padding-bottom: 20px; }\n\n.pic-upload-popup {\n  height: 100%;\n  overflow: unset; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/materials-pop-up/materials-pop-up.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/order-list/materials-pop-up/materials-pop-up.component.scss
// module chunks = main